import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SortOptionItem } from '@woolworthsnz/trader-api';
import { SearchSingleSelectComponent, Option } from '../search-single-select/search-single-select.component';

@Component({
	selector: 'search-sorter',
	standalone: true,
	imports: [SearchSingleSelectComponent],
	template: `<search-single-select
		[options]="options"
		[currentOptionValue]="currentSortOption"
		[optionsRevealApproach]="optionsRevealApproach"
		(selectChange)="applySorting($event)"
		prefixTitle="Sort"
		name="sort"
	></search-single-select>`,
	styleUrls: ['./search-sorter.component.scss'],
})
export class SearchSorterComponent {
	@Input() sortOptions: Array<SortOptionItem> = [];
	@Input() currentSortOption = '';
	@Input()
	optionsRevealApproach: 'dropdown' | 'modal' = 'dropdown';

	@Output() sortChange = new EventEmitter<string>();

	get options(): Array<Option> {
		return this.sortOptions.map(({ value = '', text = '' }) => ({
			value,
			text,
		}));
	}

	applySorting(sortOptionValue: string): void {
		this.sortChange.emit(sortOptionValue);
	}
}
